export default function () {
  let menu = '.menu'
  let $hamburgerButton = document.querySelector('.js-hamburger')
  let $body = document.querySelector('body')
  let menuActiveClass = 'menu--active'
  let bodyDisabledXsClass = 'is--disabled-xs'

  if ($hamburgerButton) {
    $hamburgerButton.addEventListener('click', function () {
      let expanded = this.getAttribute('aria-expanded')
      let $controls = document.querySelector('#' + this.getAttribute('aria-controls'))

      if (expanded === 'false') {
        this.setAttribute('aria-expanded', true)
        $controls.classList.add(menuActiveClass)
        $body.classList.add(bodyDisabledXsClass)
      } else {
        this.setAttribute('aria-expanded', false)
        $controls.classList.remove(menuActiveClass)
        $body.classList.remove(bodyDisabledXsClass)
      }
    }, false)

    document.addEventListener('click', function (event) {
      if (event.target !== document.querySelector(menu) &&
        event.target.parentNode.closest(menu) !== document.querySelector(menu) &&
        event.target !== $hamburgerButton) {
        $hamburgerButton.setAttribute('aria-expanded', false)
        document.querySelector(menu).classList.remove(menuActiveClass)
        $body.classList.remove(bodyDisabledXsClass)
      }
    })
  }
}
